<template>
  <a-row :gutter="20"  class='visit-setting' style='margin-left: 0;margin-right: 0;'>
    <a-col :span='12'>
      <a-card :bordered='false'  class="main_box">
        <event-list class="row" ref="eventList"></event-list>
        <base-line></base-line>
      </a-card>
    </a-col>
    <a-col :span='12'>
      <a-card :bordered='false'  class='main_box'>
        <period-list></period-list>
      </a-card>
    </a-col>



  </a-row>
</template>

<script>
import BaseLine from './visit/BaseLine'
import EventList from './visit/EventList'
import PeriodList from './visit/PeriodList'
export default {
  name: 'Visit',
  provide(){
    return{
      getVisitList:this.getVisitList
    }
  },
  components: { PeriodList, EventList, BaseLine},
  data() {
    return {
    }
  },

  methods: {
    getVisitList(){
      if(this.$refs.eventList){
        return this.$refs.eventList.dataSource
      }else{
        return []
      }
    }

  }
}
</script>

<style lang='less' scoped>
.visit-setting {

  .main_box {
    height: calc(100vh - 136px);
    overflow-y: auto;
  }
}
.row{
  margin-bottom: 30px;
}

</style>
<style lang="less">
  .main_box{
    .title{
      font-weight: bold;
      font-size: 16px;
      padding-left: 10px;
      border-left: 5px solid @primary-color;
    }
  }

</style>
